module.exports = __webpack_public_path__ + "media/images/pozice-d256cdd6eb09f2a3a11d38112ad28345.png";